import { deleteCache } from '@ds/swymkit/tools'
import { encodeHTMLEntities } from '@ds/swymkit/utils'

import { swymFetch } from '~/services/fetch-swym'

import { getInvitationStatus } from '~/entities/user/user/api/users'
import { type UserInvitation, UserNetworkStatus } from '~/entities/user/user/interfaces/user'

import { isUserInNetwork } from '~/features-swym/network/utils/network'
import { networkActivityParser } from '~/features-swym/network-activity/api/parser-network-activity'
import type { INetworkActivity } from '~/features-swym/network-activity/interfaces/network-activity'

import { dateParser, getContentModelFromSubjectUri } from '~/features-shared/content/api/parser-contents'
import type { ISwymContent } from '~/features-shared/content/interfaces/swym-content'
import { logger } from '~/features-shared/libs/utils/logger'

import type { SwymService } from '~/interfaces/crud-service'
import type { SwymResponse } from '~/interfaces/services-dto'

export const NetworkActivitiesSwymServices: SwymService<INetworkActivity> = {
  async count() {
    throw new Error('Function not implemented.')
  },
  async getAll(params) {
    let invitationStatusResult
    if (params.hash_key) {
      try {
        invitationStatusResult = (await getInvitationStatus(params.hash_key))?.result as UserInvitation
      }
      catch (error) { logger.log(error) }
    }
    const inNetwork = isUserInNetwork(invitationStatusResult)

    const response: SwymResponse<INetworkActivity>
    = inNetwork === UserNetworkStatus.InNetwork
      ? await swymFetch
        .post('/api/network/getnetworkactivity', {
          json: {
            params: {
              limit: params.limit,
              only_main_activity: true,
              only_raw_data: true,
              page: params.page,
              hash_key: params.hash_key,
            },
          },
        })
        .json()
        .then((response) => {
          return {
          // if content_uri_list is null, the response is not a content
            data: response.result.filter(el => el.content_uri_list?.length ?? true)
              .map((el) => {
                let subject_uri
                let model = el.type
                if (el.target_id && Array.isArray(el.content_uri_list)) {
                // eslint-disable-next-line max-nested-callbacks
                  subject_uri = [...el.content_uri_list].find(element => element.subject_uri.endsWith(el.target_id))?.subject_uri

                  if (!subject_uri)
                    return undefined

                  model = getContentModelFromSubjectUri(subject_uri/* , { derived_type: el.derived_type } */)
                }
                if (el.derived_type) {
                  el.derived_type.parent = el.type
                  el.derived_type.label = encodeHTMLEntities(el.derived_type.label)
                }

                if (el.date)
                  el.date = dateParser(el.date)

                return ({ ...el, model, subject_uri })
              })
              .filter(obj => !!obj),
          }
        })
      : await swymFetch
        .post('/api/feed/whatsnew', {
          json: {
            params: {
              limit: params.limit,
              page: params.page,
              hash_key: params.hash_key,
            },
          },
        })
        .json()
        .then((response: SwymResponse<ISwymContent>) => {
          const data = response.result.filter(el => el.subject6wuri?.length ?? true)
            .map((el) => {
              let subject_uri
              let model = el.model
              if (el.model_id) {
                subject_uri = el.subject6wuri
                if (!subject_uri)
                  return undefined

                model = getContentModelFromSubjectUri(subject_uri/* , { derived_type: el.derived_type } */)
              }
              if (el.derived_type) {
                el.derived_type.parent = el.type
                el.derived_type.label = encodeHTMLEntities(el.derived_type.label)
              }

              if (el.date)
                el.date = dateParser(el.date)

              return ({ ...el, model, subject_uri })
            })
            .filter((obj: any) => !!obj)
          return {
            data: data.map((el: ISwymContent) => networkActivityParser(el)),
          }
        })

    return response
  },
}
export function deleteUserFromNetwork(hash_key?: string) {
  return swymFetch.post('/api/networkgroup/deleteuserfromnetwork', { json: { params: { hash_key } } })
    .then(() => {
      // Remove cache for user network
      deleteCache(`user-network-${hash_key}`)
    })
}
